<template>
  <div class="card css-table">
    <div class="p-grid">
      <div class="p-col-12 p-m-auto">
        <!-- header part -->
        <table style="margin-left: 5rem" class="d-flex justify-center mt-2">
          <th></th>
        </table>
        <!-- content part -->
        <table border="1" class="text-center detail-bon" style="width: 100%">
          <thead style="font-size: 12px; height: 40px">
            <tr>
              <th scope="col" class="text-center" rowspan="2">No</th>
              <th scope="col" class="text-center" rowspan="2">Kode Barang</th>
              <th scope="col" class="text-center" rowspan="2">Nama</th>
              <th scope="col" class="text-center" rowspan="2">Tipe Mutasi</th>
              <th scope="col" class="text-center" rowspan="2">Harga</th>
              <th
                style="font-size: 12px; text-align: center"
                v-for="(item, r) in outlets"
                :key="r"
              >
                <span>{{ item.alias }}</span>
              </th>
            </tr>
          </thead>
          <tbody style="font-size: 12px" class="header">
            <tr v-for="(an_item, k) in fetch" :key="k" class="row-content">
              <td>{{ k + 1 }}</td>
              <td>{{ an_item.code }}</td>
              <td>{{ an_item.item_name }}</td>
              <td>{{ an_item.type }}</td>
              <td>{{ an_item.priceInRp | currency }}</td>
              <td
                v-for="(item, r) in an_item.warehouse_outbounds"
                :key="r"
                style="font-size: 12px; text-align: center"
              >
                <div>
                  <div
                    :style="{
                      'font-weight': item.qty ? 'bold' : 'normal',
                      border: 'none'
                    }"
                  >
                    {{ item.qty ? item.qty : 0 | number }}
                  </div>
                  <div
                    :style="{
                      'font-weight': item.qty ? 'bold' : 'normal',
                      border: 'none',
                      fontSize: '10px'
                    }"
                    v-if="an_item.type == 'SPECIAL_MUTATION'"
                  >
                    {{ item.price | number }}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div style="margin: auto">
        <Button type="button" label="Simpan" @click="submit()">
          <span v-if="loading_simpan" class="p-d-flex p-ai-center">
            Simpan
            <i class="pi pi-spin pi-spinner p-ml-2"></i>
          </span>
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    inputData: Array,
    outlets: Array,
    showModal: Boolean
  },
  watch: {
    items: {
      handler() {
        this.fetchData()
      },
      immediate: true
    }
  },
  data() {
    return {
      selectedType: null,
      selectedTypes: [
        { id: 1, code: 'REGULAR_MUTATION', name: 'Mutasi Regular' },
        { id: 2, code: 'SPECIAL_MUTATION', name: 'Mutasi Spesial' },
        { id: 3, code: 'SALE_MUTATION', name: 'Mutasi Sale' },
        { id: 4, code: 'GIFT_MUTATION', name: 'Mutasi Hadiah' }
      ],
      autoFiltered: [],
      dropdownItems: null,
      loading_simpan: false,
      items_checked: false,
      isError: {
        items: [
          {
            item_code: false,
            price: false,
            discount: false,
            qty: false
          }
        ],
        price: []
      },
      error_msg: {
        items: [
          {
            item_code: '',
            price: '',
            discount: '',
            qty: ''
          }
        ]
      },
      items_temp: [],
      price_is_null: true,
      gift_setting: false,
      save_button: true,
      initial_purchase_orders: [],
      purchaseFiltered: [],
      selectedPurchase: null,
      purchase_orders: [],
      buttonBon: true,
      buttonBon_loading: false,
      qtyOutletTotal: [],
      qtyAwalTotal: 0,
      fetch: []
    }
  },
  mounted() {
    this.fetchData()
    this.getOutlets()
    this.getInitialPurchaseOrders()
  },
  methods: {
    fetchData() {
      const items = this.items
      const inputData = this.inputData
      this.fetch = items.map(item => {
        const item_name = item.item_name ? item.item_name : 'Unknown'

        return {
          ...item,
          type: inputData.type,
          item_name: item_name
        }
      })
    },

    async getOutlets() {
      this.loading = true
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/outlets`
        )
        if (response.status === 200) {
          this.outlets = response.data.data.outlets
        } else {
          console.error('Gagal mendapatkan data outlets')
        }
      } catch (error) {
        console.error('Error fetching outlets:', error)
      } finally {
        this.loading = false
      }
    },

    async getInitialPurchaseOrders() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/initial-purchase-orders?distribution_done=false&status=1`
        )

        if (response.status === 200) {
          this.initial_purchase_orders =
            response.data.data.initial_purchase_orders
        }
      } catch (error) {
        console.error('Error fetching initial purchase orders:', error)
      }
    },

    closeModal() {
      this.$emit('close') // Emit event close untuk menutup modal
    },

    submit() {
      this.loading_simpan = true
      this.$http
        .post(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/mutations`,
          this.inputData
        )
        .then(response => {
          this.getInitialPurchaseOrders()
          if (response.status === 200) {
            this.showToast(
              'success',
              'Berhasil Tambah Mutasi',
              'Distribusi keluar berhasil dibuat'
            )
            this.loading_simpan = false
            this.closeModal()
            this.$emit('modal-closed', true)
          } else if (response.data.message === 'error.post.item_in_proggres') {
            this.showToast(
              'error',
              'Gagal Tambah Mutasi',
              'Barang sudah di input sebelumnya'
            )
            this.loading_simpan = false
            this.closeModal()
            this.$emit('modal-closed', false)
          } else {
            this.showToast(
              'error',
              'Gagal Tambah Mutasi',
              'Distribusi keluar gagal dibuat'
            )
            this.loading_simpan = false
            this.closeModal()
            this.$emit('modal-closed', false)
          }
        })
    }
  }
}
</script>

<style scoped>
td {
  padding: 5px;
  font-size: 11px;
  text-align: center;
}

th {
  padding: 5px;
}
</style>
